// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"242":"f508046c","306":"b2b2ba61","453":"03346f77","557":"714dd2c0"}[chunkId] + ".chunk.js";
};